 
import {FieldController} from "./elements.field.controller";

//var selectCreated = 0 ;

class inputSelectController  extends FieldController {
    
    static get $inject(){ return  ['$element','$log', 'BXReferenceService', 'referenceEntity', '$scope'];}
    

    constructor($element,$log, BXReferenceService, referenceEntity, $scope){
        super($log, $scope, $element);
        this.$element = $element;
        this.reference = BXReferenceService;
        this.refentity = referenceEntity;
        this.scope = $scope
        this.__model = null;
        this.query = [] ;
        this.queryState = [] ;
        this.$scope.$on('select.option.change.state', this.onChangeStateOption.bind(this));
        this.$scope.$on('field.change.state', this.onChangeState.bind(this));
        
    }

    setOptionsByListProps(){
        let options = [];
        this.listProp.items.forEach(item => {
            let option ={
                id: item.value,
                text: item.label, 
               
            };

            if(item.id){
                option.optId= item.id;
            }

            if(this.model && this.model==option.id ){
                option.selected = true
            }

            options.push(option);
        });
        this.options  = options;
    }
    $onInit() {
     
        if(this.filter){
            this.filter=this.filter.split(',');
        }
       
        
       super.$onInit();
        if(!this.placeholder){
            this.placeholder= 'Выберите значение';
        }

       
        if(this.type){

            this.entity =  this.refentity[this.type.split('.').shift()];
            this.propcode = this.type.split('.').pop();
            
            this.listProp= this.reference.getReference(this.entity);
            if(this.listProp.$$state){
                this.createSelectDelayed();
                this.listProp.then((data)=>{

                    this.listProp = data[this.propcode];
                    this.setOptionsByListProps();

                })   
                return ;
            }
            
            
            if(this.listProp){
                
                this.listProp = this.listProp[this.propcode];
            }

            if(this.listProp){
                this.setOptionsByListProps();
            }else{
               
                this.createSelectDelayed();
            }


           
        }else if(typeof this.options==='undefined'){
            
                this.options  = [];
            
        }

        

        
        
    }
    
    get model(){
        return this.__model;
    }
    set model(value){

        if(this.__model!=value){
            this.__model = value
            
            if(this.select){

        
                this.select.val(value);
                this.select.trigger('change');
            }
        }else{
            this.__model = value
        }
    }
    get options(){
        if(! this.__options){
            this.__options = [];
        }

       
        return this.__options;
    }

    set options(value){
       
        if(this.filter){
            if(!Array.isArray(this.filter)){
                this.filter = this.filter.split(',').map((el)=>el.trim());
            }
        }
        
        this.debug(this.controlClass+' set options ' , value);
        if( this.filter){
            this.__options =value.filter((el)=>this.filter.indexOf(el.id)>-1);
 
        }else{
            this.__options = value;
        }

        this.__options.unshift({
            id:'',
            text: this.placeholder
        });
        
       if(this.model){
           let item = this.__options.find((el)=>el.id==this.model);
           if(item){
                item.selected = true;
           }
       }

        if(this.select){
            this.select.select2('destroy');
        }        
       
       this.createSelectDelayed();
       
    }

    createSelectDelayed(){
        if(this.tmrCreateSelect){
            clearTimeout(this.tmrCreateSelect);
        }
        this.tmrCreateSelect =setTimeout(()=>{
            this.createSelect();
        }, 10);
    }



    createSelect(){

     
        
        
        let params ={
            placeholder: this.placeholder,
            data: this.options,
            multiple: this.multiple
        };

        if(this.tag){
          
            params.tags=true;
            params.createTag=(param)=>{
                var term = $.trim(param.term);
            
                if (term === '') {
                  return null;
                }
               

                return {
                    id: 'other-'+term,
                    text: term,
                    newTag: true // add additional parameters
                  }

            }
/*
            params.insertTag=function (data, tag) {
                
                // Insert the tag at the end of the results
                data.push(tag);
              };
              */

        }else{
            params.minimumResultsForSearch=-1;
            params.allowClear = true;
        }

        this.select = $('select', this.$element).select2(params)
            .on('select2:select', this.onSelect2.bind(this))
            .on('select2:clear', this.onClear.bind(this))
        
        
        if(this.query.length){
           
            this.query.forEach(element => {
                this.onChangeStateOption(null, element)
            });

            this.query= [] ;
        }




        if(this.queryState.length){
            this.queryState.forEach(element => {
                this.onChangeState(null, element)
            });
    
            this.queryState= [] ;
        }



       
    }

    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }
        if(!this.__model){
            this.errorMessage ='Необходимо выбрать значение'
            data.haveError(this);
        }
    }

    

    onClear(){
     

        this.modelOpt='';
        this.__model='';

        this.redraw();
        this.onSelect({
            id:'',
            text:''
        });
    }
    onSelect2(e){

        var data = e.params.data;
       
        this.__model=data.id ;
     
        if(data.optId){
            this.modelOpt=data.optId
        }


        this.haveError =false;
        this.redraw();

        this.onSelect({
            id:data.id,
            text:data.text
        });
      
    }

    onChangeStateOption(event, data){
        this.haveError =false;
        if(data.field!=this.fieldName){
            return;
        }

        if(!this.select){
            this.query.push(data);
            return ;
        }
     
        
        let option = this.select.find("option[value='" + data.optionValue + "']")

        if(option.length){
            option.prop('disabled', !data.state);
        }

        if(this.__model==data.optionValue && !data.state){
            this.model = '';
        }


    }

    onChangeState(event, data){

        if(data.field!=this.fieldName){
            return;
        }
    
        if(!this.select){
            this.queryState.push(data);
            return ;
        }

        this.select.prop("disabled", data.disabled)
        this.haveError =false;
    }

    
}



export {


    inputSelectController

}
;



// WEBPACK FOOTER //
// ./src/components/elements/input.select.controller.js